import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiGet } from "../legacy/services/apiClient";

export default function ShortLinkRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Opening stay...");

  useEffect(() => {
    let active = true;
    const encodedCode = encodeURIComponent(code || "");
    apiGet(`/api/public/short-links/${encodedCode}`).catch(() => apiGet(`/api/short-links/${encodedCode}`))
      .then((payload) => {
        if (!active) return;
        const destination = payload?.destinationPath || payload?.destination_path || "/stays";
        navigate(destination, { replace: true });
      })
      .catch(() => {
        if (!active) return;
        setMessage("Short link not found.");
      });
    return () => {
      active = false;
    };
  }, [code, navigate]);

  return <div style={{ padding: "24px", color: "#475569" }}>{message}</div>;
}
